import styles from "./Slider.module.css";
import PropTypes from "prop-types";
import SliderViewer from "./SliderViewer/SliderViewer";
import { useSlider } from "./useSlider";

const Slider = (props) => {
  const { data, max_width = false } = props;
  const [sliders] = useSlider({ productSliders: data });

  return (
    <div
      className={`${styles.SliderContainer} ${
        max_width ? styles.MaxWidth : ""
      }`}
    >
      <SliderViewer data={sliders} />
    </div>
  );
};

Slider.propTypes = {
  data: PropTypes.array,
};

export default Slider;
